import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getMonitorInsights = () => {
  const url = `${baseUrl}/v1/related-companies/insights`;
  return apiService.get(url);
};

export { getMonitorInsights };
